export default "__VITE_ASSET__BAuTiABX__"